export default "__VITE_ASSET__ccb79324__"